import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ITreeOptions, TreeComponent } from '@ali-hm/angular-tree-component';
// file.organizer.css is @imported by web/core/css/gforge-app-bundle.css and so already
// ships in the global stylesheet; a styleUrls entry here only duplicated it as a second
// runtime fetch (and is a server-absolute path the AOT compiler cannot resolve).
@Component({
    selector: 'file-organizer',
    template: require('./file.organizer.html')
})
export class FileOrganizerComponent implements OnInit {
  @ViewChild('tree', { static: false }) tree!: TreeComponent;

  @Input() foldersFile: any[];

  options: ITreeOptions = {
    displayField: 'title',
    useVirtualScroll: false,
    allowDrag: false,
    animateExpand: true,
    animateSpeed: 30,
    animateAcceleration: 1.2,
    nodeHeight: 23
  };

  constructor() { }

  ngOnInit() {    
  }

  ngAfterViewInit() {
    this.expandAllNodes();
  }
  
  expandAllNodes() {
    this.tree.treeModel.expandAll();
  }
}
